import { Form, Select } from "antd";
import styles from "../styles.module.css";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { setLoadingSurvey } from "../../../redux/slices/loadingSurvey";
import useSurvey from "../../../pages/surveys/hooks/useSurvey";

const ConditionalItem = ({ option, index, question, surveyId }) => {
  const { pageId } = useParams();
  const surveyInfo = useSelector((state) => state.surveyInfo);
  const questions = surveyInfo?.surveyPages
    ?.find((page) => page.id === Number(pageId))
    ?.surveyQuestions?.filter((item) => item.id !== question.id);
  const { getSurveyInfo, updateSurveyOption } = useSurvey();

  const dispatch = useDispatch();

  const handleUpdateSurveyOption = async (go_to) => {
    dispatch(setLoadingSurvey(true));
    const res = await updateSurveyOption({
      id_question_option: option.id,
      option: option.option,
      go_to,
    });

    if (res) {
      await getSurveyInfo(Number(surveyId));
    }
    dispatch(setLoadingSurvey(false));
  };

  return (
    <div
      style={{ position: "relative" }}
      className={styles["survey-question-option-container"]}
    >
      <span className={styles["conditional-label"]}>Ir a</span>
      <Form.Item
        className={styles["survey-question-option-item"]}
        name={`go_to_${index + 1}`}
        label=" "
        initialValue={option.go_to}
      >
        <Select
          defaultValue={null}
          options={[
            {
              label: "Siguiente pregunta",
              value: null,
            },
            ...(Array.isArray(questions) ? questions : []).map((item) => ({
              label: item.question_description,
              value: item.id,
            })),
          ]}
          onChange={(value) => handleUpdateSurveyOption(value)}
          placeholder="Seleccionar"
        />
      </Form.Item>
    </div>
  );
};

export default ConditionalItem;
